<app-dialog-structure [title]="data ? 'Edit Customer': 'Add Customer'" [submitButton]="data ? 'SAVE' : 'ADD'" (cancel)="close()" (submit)="save()" [disableAction]="customerForm.invalid">
  <div [formGroup]="customerForm" class="display-layout-column">
    <mat-form-field>
      <mat-label>Company Name</mat-label>
      <input matInput formControlName="companyName" type="text" required />
      @if (customerForm.controls['companyName'].hasError('required')) {
        <mat-error
          >
          Company Name is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input matInput formControlName="firstName" type="text" required/>
      @if (customerForm.controls['firstName'].hasError('required')) {
        <mat-error
          >
          First Name is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName" type="text" required />
      @if (customerForm.controls['lastName'].hasError('required')) {
        <mat-error>
          Last Name is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>E-Mail</mat-label>
      <input matInput formControlName="email" type="email"  required/>
      @if (customerForm.controls['email'].hasError('required')) {
        <mat-error>
          E-Mail is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>
  </div>
</app-dialog-structure>
